const SMALLEST_SHOWN = 0.0001

/** `0.0123`; a dust balance reads `<0.0001`, not a misleading zero. */
export const formatSolAmount = (value: number): string => {
  if (value > 0 && value < SMALLEST_SHOWN) return `<${SMALLEST_SHOWN}`

  return value.toLocaleString('en-US', { maximumFractionDigits: 4 })
}

/** `0.0123 SOL` */
export const formatSol = (value: number): string =>
  `${formatSolAmount(value)} SOL`
